import UsuarioConsultanteGrid from "components/Elements/UsuarioConsultanteGrid";
import React from "react";
import {
  Button,
  Card,
  Container,
  Row,
  Col
 } from "react-bootstrap";
 import { useNavigate} from 'react-router-dom';
 import { useUsuarioSistema } from '../hooks/useUsuarioSistema';

function ListarUsuariosConsultantes(Usuario) {
    let navigate = useNavigate();
    let usuario=Usuario.usuarioActual.Usuario;
    const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
  const usuarioActual=usuarioActualSistema?.usuarioSistema;
   
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Listado de usuarios consultantes</Card.Title>
                  <p className="card-category">
                    En esta sección puede ingresar nuevos consultantes o revisar fichas de consultantes
                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                <div className="button-container mr-auto ml-auto">
                {
                usuarioActual?.Roles?.includes(1) || usuarioActual?.Roles?.includes(2) ||
                usuarioActual?.Roles?.includes(3) || usuarioActual?.Roles?.includes(4)?
                <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="info"
                  onClick={ ()=>
                    navigate('/admin/IngresarUsuarioConsultante')
                  }
                  
                  >Ingresar Usuario Consultante</Button>:null
                }

                <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="info"
                  onClick={ ()=>
                    navigate('/admin/ListarConsultantesHistorico')
                  }
                  
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Listado Histórico&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Button>
                
                  
                  </div>
                  <UsuarioConsultanteGrid></UsuarioConsultanteGrid>
                  
                </Card.Body>
              </Card>
            </Col>
        </Row>
        
        </Container>
      </>
    );
  
  
}

export default ListarUsuariosConsultantes;
